import { LorenMetering } from "../../../../features/loren-assets/interfaces/loren-metering.interface";
import { LorenDashboardCardMeteringView } from "../interfaces/loren-dashboard-card-metering-view.interface";
import { LorenDashboardCardMeteringData } from "../interfaces/loren-dashboard-card-metering-data.interface";
import { LorenMeteringType } from "../../../../features/loren-assets/interfaces/loren-metering-type";
import { LorenAsset } from "../../../../features/loren-assets/interfaces/loren-asset.interface";
import { LorenDevice } from "../../../../features/loren-devices/interfaces/loren-device.interface";
import { LorenDashboardCardModel } from "../interfaces/loren-dashboard-card-model.interface";

export class LorenDashboardCardUtilsService {
  static transformAssetToDashboardCardModel(
    asset: LorenAsset,
    devices: readonly LorenDevice[],
  ): LorenDashboardCardModel {
    if (!asset) {
      return;
    }

    const meteringViews = LorenDashboardCardUtilsService.prepareMeteringViews(asset, devices);

    return {
      assetId: asset.id,
      assetName: asset.name,
      assetGroups: asset.groups,
      assetDescription: asset.description,
      assetAvatar: asset.image,
      meteringRaw: asset.metering,
      assetRaw: asset,
      meteringViews,
    };
  }

  static prepareMeteringViews(
    asset: LorenAsset,
    allDevices: readonly LorenDevice[],
  ): LorenDashboardCardMeteringView[] {
    const meteringViews: LorenDashboardCardMeteringView[] = [];

    asset.metering
      .forEach((m) => {
        const cardViews = LorenDashboardCardUtilsService.transformLorenMeteringToMeteringView([m]);

        meteringViews.push(cardViews);
      });

    this.updateMeteringViewsData(meteringViews, allDevices);

    return meteringViews;
  }

  private static transformLorenMeteringToMeteringView(metering: LorenMetering[]): LorenDashboardCardMeteringView {
    if (!metering) {
      return null;
    }

    const viewMeteringData: LorenDashboardCardMeteringData[] = [];

    metering.forEach((m) => {
      // special case when metering type id presence and there are no guests inside this asset
      if (m.type === LorenMeteringType.PRESENCE_SENSOR && m.data.length === 0) {
        viewMeteringData.push({
          id: "host_of",
          value: null,
        });
        return;
      }

      m.data.forEach((d) => {
        viewMeteringData.push({
          id:
            m.type !== LorenMeteringType.GPS_TRACKER_SENSOR &&
            m.type !== LorenMeteringType.PRESENCE_SENSOR &&
            m.type !== LorenMeteringType.FILL_LEVEL_SENSOR
              ? m.type
              : d.key,
          value: d.value,
          time: d.time,
        });
      });
    });

    return {
      data: viewMeteringData,
      sensorId: metering[0].sensorId,
      meteringId: metering[0].id,
      time: new Date(metering[0].time),
      type: metering[0].type,
      deviceId: metering[0].deviceId,
      meteringContext: metering[0].meteringContext,
      description: metering[0].description,
    };
  }

  private static updateMeteringViewsData(
    meteringViews: LorenDashboardCardMeteringView[],
    allDevices: readonly LorenDevice[]
  ) {
    meteringViews.forEach((view) => {
      const meteringDevice = allDevices.find((d) => d.id === view.deviceId);
      if (meteringDevice) {
        view.locationValidityPeriod = meteringDevice.locationValidityPeriod;
      }
    });
  }
}
